import React, { FC } from 'react'

import AccountTitle from '../components/AccountTitle'

const DebitTitle: FC<{ FormName: string }> = ({ FormName }) => <AccountTitle FormName={FormName} name="DebitTitleUNI" />

export default DebitTitle
